// Styles
import '../assets/styles/main.scss'
import 'aos/dist/aos.css'
import { useEffect, useState } from 'react'

// Libraries
import AOS from 'aos'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

// Components
import LoadingCover from '../components/loading-cover/'

const Layout = (props) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    AOS.init({
      once: true,
      duration: 600
    })

    // Despues de 1000 milisegundos (1 segundo)
    // va a cambiar al estado a `false`.
    setTimeout(() => {
      setLoading(false)
    }, 3000)
  }, [])

  const { t } = useTranslation()
  return (
    <main data-aos="fade">
      <Helmet>
        <title>{t('seo.title')}</title>
        <meta name="description" content={t('seo.description')} />
      </Helmet>
      <LoadingCover visible={loading} />
      {props.children}
    </main>
  )
}

export default Layout
